export default __webpack_public_path__ + "static/covid-care-service-food-img-810fad9ba73569e4bb674ccc7948eaf9.png";